import { render, staticRenderFns } from "./HutangVendor.vue?vue&type=template&id=2dbc6376&scoped=true&"
import script from "./HutangVendor.vue?vue&type=script&lang=js&"
export * from "./HutangVendor.vue?vue&type=script&lang=js&"
import style0 from "./HutangVendor.vue?vue&type=style&index=0&id=2dbc6376&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc6376",
  null
  
)

export default component.exports